import RefDiagnosa from "@/services/bridgingVclaim/RefDiagnosa";
// import UserLogin from "@/utility/User";


import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";

@Module({ store, dynamic: true, name: "storeRefDiagnosa" })
class RefDiagnosaStore extends VuexModule {
  refDiagnosa = [];




  @Mutation SET_REF_DIAGNOSA(refDiagnosa) {
    this.refDiagnosa = refDiagnosa;
  }

  @Action act_ref_diagnosa(nama) {
    const dt = RefDiagnosa.getRefDiagnosa(nama)
    dt.then(dt => {
      const refDiagnosa = dt.data
      this.SET_REF_DIAGNOSA(refDiagnosa);
    });
  }


}

export const storeRefDiagnosa = getModule(RefDiagnosaStore);
